import {
  ExegesisSlateBlock,
  INoteByIdQuery,
  OverrideSQuery,
} from '@rhizome/pgtypes';
import { PlatePluginComponent } from '@udecode/plate-core';
import { DarkenSlightly } from 'apps/exegesis/styles/themes';
import { useRouter } from 'next/router';
import React, { useContext, useLayoutEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useFetcher } from '../../../utils/DataFetchers';
import { NoteIdContext } from '../SlateEditorWrapper';
import { BlockWrapperBacklinks } from './BlockWrapperBacklinks';

export function createBlockWrapper(Child: PlatePluginComponent) {
  return function BlockWrapperComponent(props: {
    element: ExegesisSlateBlock;
    attributes: any;
  }) {
    const noteId = useContext(NoteIdContext);
    const router = useRouter();
    // for private notes, the first may be defined, for public notes, the second may be defined
    const hash = router?.asPath?.split('#')?.[1] || router?.query?.excerpt;
    const { data: note } = useFetcher<OverrideSQuery<INoteByIdQuery>>(
      [
        'NoteById',
        {
          note_id: noteId,
          note_public: null,
          note_author: null,
          note_title: null,
        },
      ],
      {
        // enable it on public notes only
        // because the note will not have been fetched yet
        enabled: false,
        // staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      }
    );

    // TODO: this doesn't work on public lmfao
    // get a list of backlinks
    const backlinks = useMemo(
      () =>
        note?.find((el) => {
          return el.block_id === props.element.id;
        })?.backlinkarray || [],
      [note, props.element.id]
    );

    // scroll to focused excerpt
    useLayoutEffect(() => {
      if (hash === props.element.id) {
        const query = `[data-block-id="${hash}"]`;
        const focusedBlock = document.querySelectorAll(query);
        console.log('FOCUSED BLOCK', focusedBlock[0], query);
        if (focusedBlock && focusedBlock.length > 0) {
          // TODO: oh my god why the fuck does this work?
          setTimeout(() => {
            (focusedBlock?.[0] as HTMLElement)?.focus();
            focusedBlock?.[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              // inline: 'nearest',
            });
          }, 0);
        }
      }
    }, [hash, props?.element?.id]);

    // tabIndex -1 to allow block to be focused
    return (
      <BlockWrapperStyle
        data-block-id={props?.element?.id}
        tabIndex={-1}
        key={props?.element?.id}
      >
        {/* <div {...props.attributes}> */}
        <Child {...props} />
        {/* </div> */}
        {backlinks?.length > 0 ? (
          <div contentEditable={false}>
            <BlockWrapperBacklinks
              backlinks={backlinks}
              block_id={props.element.id}
            />
          </div>
        ) : null}
      </BlockWrapperStyle>
    );
  };
}

export function createSimpleBlockWrapper(Child: PlatePluginComponent) {
  return function BlockWrapperComponent(props: {
    element: ExegesisSlateBlock;
    attributes: any;
  }) {
    // tabIndex -1 to allow block to be focused
    return (
      <BlockWrapperStyle
        data-block-id={props?.element?.id}
        tabIndex={-1}
        key={props?.element?.id}
      >
        <Child {...props} />
      </BlockWrapperStyle>
    );
  };
}

const BlockWrapperStyle = styled.div`
  :hover {
    background-color: ${DarkenSlightly};
  }
  :focus {
    background-color: ${DarkenSlightly};
    outline: none;
  }
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  border-radius: 0.5rem;
`;
